import React from "react"

import VisitDay from "components/Tvendo/Sale/DataMaster/VisitDay/List.js"

export default function () {

  return (

    <VisitDay></VisitDay>
  )
}